import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import clsx from 'clsx';
import { IconContextService } from '../icon-context.service';

export const iconTypes = [
  'actions-menu',
  'add-image',
  'advertisement',
  'alert',
  'analytics',
  'apple',
  'arrow-down',
  'arrow-up',
  'arrow-left',
  'arrow-right',
  'back',
  'badge',
  'ban',
  'billing',
  'billing-info',
  'billing-voucher',
  'building',
  'calendar',
  'caret-down',
  'call-bell',
  'cash-register',
  'catalog',
  'cellphone',
  'change-password',
  'check',
  'checkout',
  'chevron-down',
  'chevron-up',
  'chevron-left',
  'chevron-right',
  'clock',
  'clone',
  'close',
  'copy',
  'coupons',
  'crop',
  'cross-arrows',
  'cutlery',
  'controls',
  'customization',
  'delivery-shipping',
  'design',
  'desktop',
  'dine-in',
  'donation',
  'download',
  'edit',
  'email',
  'external-link',
  'eye-slash',
  'eye',
  'facebook',
  'filter',
  'folder',
  'form',
  'geolocation',
  'google',
  'groups',
  'growth',
  'help',
  'home',
  'hurry',
  'image',
  'info',
  'instagram',
  'instagram-shop',
  'integrations',
  'lifebuoy',
  'link',
  'loading',
  'lock',
  'magic-wand',
  'map-marker',
  'marketing',
  'menu',
  'microsoft',
  'minus-sign',
  'note',
  'notification',
  'orders',
  'parcel-shipping',
  'payment',
  'phone',
  'plus-circle',
  'plus-sign',
  'price-discount',
  'price-update',
  'promotions',
  'print',
  'print-settings',
  'qr-code',
  'return',
  'remove-circle',
  'rocket',
  'search',
  'search-engine',
  'self-service-tray',
  'settings',
  'share',
  'shipping',
  'sign-out',
  'sort',
  'sort-order',
  'sound',
  'sound-disabled',
  'statistics',
  'status-update',
  'stock',
  'store',
  'subscription',
  'supplies',
  'table',
  'table-map',
  'tablet',
  'tags',
  'takeaway-bag',
  'ticket',
  'tiktok',
  'trash-can',
  'twitter',
  'unlink',
  'upsell',
  'user',
  'users',
  'waiter',
  'web',
  'whatsapp',
  'youtube',
  'moto-zap',
  'zoom',
  'integrations-link',
  'view-kanban',
  'view-table',
] as const;

export const iconSizes = ['xxs', 'xs', 'sm', 'md', 'lg'] as const;

export const iconColors = [
  'inherit',
  'blue',
  'pink',
  'yellow',
  'cyan',
  'theme1',
  'theme1-contrast',
  'theme2',
  'theme2-contrast',
  'success',
  'danger',
  'warning',
  'info',
  'white',
  'black',
];

export type IconTypes = typeof iconTypes;
export type IconType = IconTypes[number];
export type IconSize = (typeof iconSizes)[number];
export type IconColor = (typeof iconColors)[number];

@Component({
  selector: 'pxw-icon:not([icon])',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  encapsulation: ViewEncapsulation.None,
})
export class IconComponent {
  protected iconContext = inject(IconContextService, { optional: true });

  @Input() icon: IconType | undefined;
  @Input() size: IconSize = 'sm';
  @Input() color: IconColor = 'inherit';
  @Input() spin = false;
  @Input() disabled = false;

  get iconSize() {
    return this.iconContext?.size || this.size;
  }

  @HostBinding('class')
  get classes() {
    return clsx('pxw-icon', `pxw-icon--size-${this.size}`, `pxw-icon--color-${this.color}`, {
      'pxw-icon--spin': this.spin,
      'pxw-icon--disabled': this.disabled,
    });
  }
}
